module.exports = [{"id":1,"src":"./images/class1.jpg","text":"Kiev National University of Civil Engineering and Architecture","link":"http://www.knuba.edu.ua/eng/"},{"id":2,"src":"./images/class2.jpg","text":"I have completed course - Full Stack Web and Multiplatform Mobile App Development Specialization","link":"https://www.coursera.org/specializations/full-stack-mobile-app-development"},{"id":3,"src":"./images/class3.jpg","text":"Internship in dinamicka.com","link":"http://dinamicka.com/"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/classes.json
// module id = 255
// module chunks = 0